import { DayOfWeek } from "../domain_objects/AvailabilitySearchResponse";
import { CrossSellVenueAndAvailability } from "../types/CrossSellVenueAndAvailability";

export const crossSellVenueAndAvailabilities: CrossSellVenueAndAvailability[] =
  [
    {
      CrossSellVenue: {
        Name: "Cross Sell Venue 1",
        MicrositeName: "CrossSellVenue1Microsite",
        Address: "Address for Venue 1",
        City: "Cross Sell Venue 1 City",
        Latitude: 1.23456789,
        Longitude: 1.23456789,
        Priority: 1,
      },
      AvailabilitySearchResponse: {
        MicrositeName: "CrossSellVenue1Microsite",
        TimeSlots: [
          {
            TimeSlot: "10:00",
            IsLeaveTimeRequired: true,
            LeaveTime: "11:00",
            ServiceId: 1,
            HasStandardAvailability: true,
            AvailablePromotions: [
              {
                Id: 1,
                FeeAmount: 1.23,
                LeaveTime: "11:00",
                BasePrice: 4.56,
              },
            ],
            StandardAvailabilityFeeAmount: 7.89,
          },
        ],
        Promotions: [
          {
            Id: 1,
            Name: "Promotion 1",
            Description: "Promotion 1 Description",
            MayRequireCreditCard: true,
            ValidityPeriods: [
              {
                StartDate: "2025-06-05",
                EndDate: "2025-06-05",
                StartTime: "10:00",
                EndTime: "11:00",
                Frequency: [
                  DayOfWeek.Monday,
                  DayOfWeek.Tuesday,
                  DayOfWeek.Wednesday,
                  DayOfWeek.Thursday,
                  DayOfWeek.Friday,
                ],
                IsAlwaysApply: true,
                DayVariables: [
                  {
                    DayOfWeek: DayOfWeek.Monday,
                    Price: 1.23,
                  },
                ],
              },
            ],
            FullPrice: 4.56,
            MenuVersionId: 7,
            MenuName: "Menu 1",
            MenuUrl: "Menu 1 URL",
            TakeawayType: 8,
          },
        ],
        StandardAvailabilityMayRequireCreditCard: true,
      },
    },
    {
      CrossSellVenue: {
        Name: "Cross Sell Venue 2",
        MicrositeName: "CrossSellVenue2Microsite",
        Address: "Address for Venue 2",
        City: "Cross Sell Venue 2 City",
        Latitude: 1.23456789,
        Longitude: 1.23456789,
        Priority: 2,
      },
      AvailabilitySearchResponse: {
        MicrositeName: "CrossSellVenue2Microsite",
        TimeSlots: [
          {
            TimeSlot: "10:00",
            IsLeaveTimeRequired: true,
            LeaveTime: "11:00",
            ServiceId: 1,
            HasStandardAvailability: true,
            AvailablePromotions: [
              {
                Id: 1,
                FeeAmount: 1.23,
                LeaveTime: "11:00",
                BasePrice: 4.56,
              },
            ],
            StandardAvailabilityFeeAmount: 7.89,
          },
        ],
        Promotions: [
          {
            Id: 1,
            Name: "Promotion 1",
            Description: "Promotion 1 Description",
            MayRequireCreditCard: true,
            ValidityPeriods: [
              {
                StartDate: "2025-06-05",
                EndDate: "2025-06-05",
                StartTime: "10:00",
                EndTime: "11:00",
                Frequency: [
                  DayOfWeek.Monday,
                  DayOfWeek.Tuesday,
                  DayOfWeek.Wednesday,
                  DayOfWeek.Thursday,
                  DayOfWeek.Friday,
                ],
                IsAlwaysApply: true,
                DayVariables: [
                  {
                    DayOfWeek: DayOfWeek.Monday,
                    Price: 1.23,
                  },
                ],
              },
            ],
            FullPrice: 4.56,
            MenuVersionId: 7,
            MenuName: "Menu 1",
            MenuUrl: "Menu 1 URL",
            TakeawayType: 8,
          },
        ],
        StandardAvailabilityMayRequireCreditCard: true,
      },
    },
    {
      CrossSellVenue: {
        Name: "Cross Sell Venue 3",
        MicrositeName: "CrossSellVenue3Microsite",
        Address: "Address for Venue 3",
        City: "Cross Sell Venue 3 City",
        Latitude: 1.23456789,
        Longitude: 1.23456789,
        Priority: 2,
      },
      AvailabilitySearchResponse: {
        MicrositeName: "CrossSellVenue3Microsite",
        TimeSlots: [
          {
            TimeSlot: "10:00",
            IsLeaveTimeRequired: true,
            LeaveTime: "11:00",
            ServiceId: 1,
            HasStandardAvailability: true,
            AvailablePromotions: [
              {
                Id: 1,
                FeeAmount: 1.23,
                LeaveTime: "11:00",
                BasePrice: 4.56,
              },
            ],
            StandardAvailabilityFeeAmount: 7.89,
          },
        ],
        Promotions: [
          {
            Id: 1,
            Name: "Promotion 1",
            Description: "Promotion 1 Description",
            MayRequireCreditCard: true,
            ValidityPeriods: [
              {
                StartDate: "2025-06-05",
                EndDate: "2025-06-05",
                StartTime: "10:00",
                EndTime: "11:00",
                Frequency: [
                  DayOfWeek.Monday,
                  DayOfWeek.Tuesday,
                  DayOfWeek.Wednesday,
                  DayOfWeek.Thursday,
                  DayOfWeek.Friday,
                ],
                IsAlwaysApply: true,
                DayVariables: [
                  {
                    DayOfWeek: DayOfWeek.Monday,
                    Price: 1.23,
                  },
                ],
              },
            ],
            FullPrice: 4.56,
            MenuVersionId: 7,
            MenuName: "Menu 1",
            MenuUrl: "Menu 1 URL",
            TakeawayType: 8,
          },
        ],
        StandardAvailabilityMayRequireCreditCard: true,
      },
    },
    {
      CrossSellVenue: {
        Name: "Cross Sell Venue 4",
        MicrositeName: "CrossSellVenue4Microsite",
        Address: "Address for Venue 4",
        City: "Cross Sell Venue 4 City",
        Latitude: 1.23456789,
        Longitude: 1.23456789,
        Priority: 2,
      },
      AvailabilitySearchResponse: {
        MicrositeName: "CrossSellVenue4Microsite",
        TimeSlots: [
          {
            TimeSlot: "10:00",
            IsLeaveTimeRequired: true,
            LeaveTime: "11:00",
            ServiceId: 1,
            HasStandardAvailability: true,
            AvailablePromotions: [
              {
                Id: 1,
                FeeAmount: 1.23,
                LeaveTime: "11:00",
                BasePrice: 4.56,
              },
            ],
            StandardAvailabilityFeeAmount: 7.89,
          },
        ],
        Promotions: [
          {
            Id: 1,
            Name: "Promotion 1",
            Description: "Promotion 1 Description",
            MayRequireCreditCard: true,
            ValidityPeriods: [
              {
                StartDate: "2025-06-05",
                EndDate: "2025-06-05",
                StartTime: "10:00",
                EndTime: "11:00",
                Frequency: [
                  DayOfWeek.Monday,
                  DayOfWeek.Tuesday,
                  DayOfWeek.Wednesday,
                  DayOfWeek.Thursday,
                  DayOfWeek.Friday,
                ],
                IsAlwaysApply: true,
                DayVariables: [
                  {
                    DayOfWeek: DayOfWeek.Monday,
                    Price: 1.23,
                  },
                ],
              },
            ],
            FullPrice: 4.56,
            MenuVersionId: 7,
            MenuName: "Menu 1",
            MenuUrl: "Menu 1 URL",
            TakeawayType: 8,
          },
        ],
        StandardAvailabilityMayRequireCreditCard: true,
      },
    },
  ];
